import { schema } from "normalizr";
import { MasterSchemaRecord } from "records/schema";

export const MasterSchema = new schema.Entity(
    "masterSchema",
    {},
    {
        idAttribute: "_id",
    }
);

(MasterSchema as any).record = MasterSchemaRecord;
